import { endpoints } from "config/endpoints.config"
import { IGenericModel, generic } from "models/generic"
import { IBuySMSTransaction } from "./adminTransactions"

export const smsTransactions: IGenericModel<IBuySMSTransaction> = {
  ...generic(endpoints.SMS_TRANSACTIONS),
}
